module.exports = __webpack_public_path__ + "static/media/slide4.1.883976de.png";